// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ApplicationProtocolSchema = z.enum(['HTTP','HTTPS','SSH','TLS','DNS','SMTP','SMTPS','FTP','FTPS','LDAP','LDAPS','SNMP','TELNET','RDP','SMB','MYSQL','POSTGRES','MSSQL','MONGODB','REDIS','VNC','IKE','OPENVPN','SIP','IMAP','IMAPS','POP3','POP3S','RTSP','H323','XMPP','NTP','TFTP','OTHER'] as const);

export type ApplicationProtocolType = `${z.infer<typeof ApplicationProtocolSchema>}`

export default ApplicationProtocolSchema;
